import React from 'react';
//css
import './app.scss';
//react-redux
import { connect } from 'react-redux';
//ccomponents
import Header from './components/Header/Header';
import Burger from './components/Burger/Burger';
import Menu from './components/Menu/Menu';
import HomeButton from './components/HomeButton/HomeButton';
import ProjectA from './components/ProjectA/ProjectA';
import ProjectB from './components/ProjectB/ProjectB';
import ProjectC from './components/ProjectC/ProjectC';
import ProjectD from './components/ProjectD/ProjectD';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import DownArrow from './components/Icons/downArrow';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      position: window.pageYOffset,
    };
  }
  componentDidMount() {
    window.addEventListener('scroll', this.listenToScroll);
  }
  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    const scrolled = winScroll / height;

    this.setState({
      position: scrolled,
    });
  };
  render() {
    return (
      <div className="Main">
        <Header />
        <DownArrow opacity={Math.pow(Math.abs(this.state.position - 1), 20)} />
        <ProjectD />
        <ProjectA />
        <ProjectB />
        <ProjectC />
        <About />
        <Contact />
        {/*<Footer />*/}
        <Burger openSlide={this.props.slideMenu} scroll={this.state.position} />
        <Menu openSlide={this.props.slideMenu} scroll={this.state.position} />
        <HomeButton />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  slideMenu: state.nav.menuSlide,
});

export default connect(mapStateToProps)(App);
